<template>
  <div class="row gy-8 gy-md-4 gx-md-8">
    <div v-for="button in buttons" :key="button.id" class="col-12 col-md-6">
      <strapi-button :component="button" :size="'small'" class="w-100" />
    </div>
    <!-- social media buttons go here -->
  </div>
</template>

<script lang="ts">
import type { StrapiButton } from '~/apollo/types/types';

export default defineComponent({
  props: {
    buttons: {
      type: Array as PropType<Array<StrapiButton>>,
      default: () => [],
    },
  },
});
</script>
